var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_481)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_386_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_386_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 11.33L16 12.71V15H12V12.71L14 11.33ZM14 9.01001C13.9 9.01001 13.8 9.04001 13.71 9.10001L10.28 11.47C10.1 11.59 10 11.81 10 12.05V16.33C10 16.7 10.26 17.01 10.57 17.01H17.43C17.75 17.01 18 16.71 18 16.33V12.05C18 11.81 17.89 11.59 17.72 11.47L14.29 9.10001C14.2 9.04001 14.1 9.01001 14 9.01001Z",
    fill: "#171E26",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18V18.08C4 18.59 4.41 19 4.92 19H5C4.45 19 4 18.55 4 18ZM5 19H5.08C5.59 19 6 18.59 6 18.08V18C6 18.55 5.55 19 5 19Z",
    fill: "#171E26",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02 18.31C2.12 19.74 3.26 20.88 4.69 20.98C3.28 20.84 2.16 19.72 2.02 18.31Z",
    fill: "#171E26",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.97 5H7.85C7.47 3.84 6.37 3 5.08 3H4.92C3.31 3 2 4.31 2 5.92V18.08C2 18.16 2 18.23 2.02 18.31C2.16 19.72 3.28 20.84 4.69 20.98C4.77 21 4.84 21 4.92 21H20.97C21.54 21 22 20.54 22 19.97V6.03C22 5.46 21.54 5 20.97 5ZM4 5.92C4 5.41 4.41 5 4.92 5H5.08C5.59 5 6 5.41 6 5.92V15.18C5.69 15.06 5.35 15 5 15C4.65 15 4.31 15.06 4 15.18V5.92ZM4.92 19C4.41 19 4 18.59 4 18.08V18C4 17.45 4.45 17 5 17C5.55 17 6 17.45 6 18V18.08C6 18.59 5.59 19 5.08 19H4.92ZM20 19H8V7H20V19Z",
    fill: "#171E26",
    fillOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseOff);
export default __webpack_public_path__ + "static/media/house_off.7105d1a52ca96b23db78d05ba48ff79b.svg";
export { ForwardRef as ReactComponent };